
<j-process-node-group
    :source="node"
    v-on="$listeners"
    :configs="configs">
    <j-group :configs="iconGroup">
        <j-icon :configs="imageConfig" />
    </j-group>

    <j-group :configs="textGroup">
        <j-text :configs="{
            fontSize: '14px',
            textColor: '#333',
            content: node.title || node.name,
            width: 128,
            ellipsis: true,
            textAlign: 'left'
        }">
        </j-text>
    </j-group> 
</j-process-node-group>
